import { isDraftSaveAction } from '../../../../Draft'
import { RentalPortalApplicantDraftCloseActionSelectModal } from '../../RentalPortalApplicantDraftCloseActionSelectModal'

export function useRentalPortalApplicantDraftCloseConfirmation(setDraft) {
  return {
    Component: RentalPortalApplicantDraftCloseActionSelectModal,
    onSubmit: action => {
      if (!isDraftSaveAction(action)) {
        setDraft(null, 0)
      }
    },
  }
}
